export enum PreloadingStatus {
    Created = 1,
    Processed = 2,
    Loaded = 3,
}

export const enumLabel = (value?: PreloadingStatus) => {
    switch (value) {
        case PreloadingStatus.Created:
            return 'На проверке';
        case PreloadingStatus.Processed:
            return 'Обработан';
        case PreloadingStatus.Loaded:
            return 'Отгружен';
        default:
            return '';
    }
};
